module.exports = __webpack_public_path__ + "static/media/O-2-Confirm-Transformer-Voltage-Rating.e0fe53b5.svg";